/**
 * NOT CHECKED
 */
import DashboardIcon from '@uikit/old/SidebarIcon/_components/DashboardIcon';
import React from 'react';

import ToolboxIcon from '@uikit/old/SidebarIcon/_components/ToolboxIcon';
import { PRIMARY_COLOR } from '@constants/colors';
import CampaignsIcon from './_components/CampaignsIcon';
import AutomationsIcon from './_components/AutomationsIcon';
import InboxIcon from './_components/InboxIcon';
import InsightsIcon from './_components/InsightsIcon';
import RelationshipsIcon from './_components/RelationshipsIcon';
import InquiriesIcon from './_components/InquiriesIcon';
import AiStarIcon from '@uikit/old/Icon/svgIcons/aiStarIcon';
import BucketLinkIcon from '@uikit/old/Icon/svgIcons/BucketLinkIcon';
import SquareLinkIcon from '@uikit/old/Icon/svgIcons/SquareLinkIcon';
import BucketWithArrow from '@uikit/old/Icon/svgIcons/BucketWithArrow';
import WidgetIcon from '@uikit/old/Icon/svgIcons/WidgetIcon';
import EaselIcon from '@uikit/old/Icon/svgIcons/EaselIcon';

type SidebarIconPropsType = {
  isActive?: boolean;
  type: string;
};

export default ({ type }: SidebarIconPropsType): JSX.Element => {
  const color = PRIMARY_COLOR;

  switch (type) {
    case 'dashboard':
      return <DashboardIcon color={color} />;
    case 'campaigns':
      return <CampaignsIcon color={color} />;
    case 'automations':
      return <AutomationsIcon color={color} />;
    case 'inbox':
      return <InboxIcon color={color} />;
    case 'insights':
      return <InsightsIcon color={color} />;
    case 'relationships':
      return <RelationshipsIcon color={color} />;
    case 'inquiries':
      return <InquiriesIcon color={color} />;
    case 'toolbox':
      return <ToolboxIcon color={color} />;
    case 'aiStar':
      return <AiStarIcon color={color} />;
    case 'bucketLink':
      return <BucketLinkIcon color={color} />;
    case 'bucketWithArrow':
      return <BucketWithArrow color={color} />;
    case 'widget':
      return <WidgetIcon color={color} />;
    case 'easel':
      return <EaselIcon color={color} />;
    case 'squareLink':
      return <SquareLinkIcon color={color} />;
    default:
      return null;
  }

  return null;
};
